module.exports = "../../../../platform/assets/pageMainIcon/simple_baobiaochaxunlei6.svg";